import type { FC } from "react"

import type { AdjustmentSelectedLot } from "../../types"
import { AdjustmentSelectedLots } from "../AdjustmentSelectedLots"

import { formatNumber } from "@/utils/number"

interface CombinePalletsAdjustmentFormLotsProps {
  selectedLots: AdjustmentSelectedLot[]
  uomName: string
  onLotRemove: (lotId: string) => void
}

export const CombinePalletsAdjustmentFormLots: FC<CombinePalletsAdjustmentFormLotsProps> = ({
  selectedLots,
  uomName,
  onLotRemove,
}) => {
  const combinedTotal = selectedLots.reduce((sum, lot) => sum + (lot.totalUnits ?? 0), 0)

  return (
    <AdjustmentSelectedLots
      selectedLots={selectedLots}
      uomName={uomName}
      testIdPrefix='inventory.combine-pallets-adjustment-form-lots'
      title='Review Lots Being Merged'
      emptyState={{
        title: "No pallets selected",
        description: "Select two or more pallets from the table above to combine.",
      }}
      footer={{
        label: "Combined Total",
        render: () => `${formatNumber(combinedTotal)} ${uomName}`,
      }}
      onLotRemove={onLotRemove}
    />
  )
}
